export const productTagsTypes = [
    {label: "Tous", value: "ALL"},
    {label: "Internes", value: "INTERNAL", enableValue: true},
    {label: "Types de recette", value: "DISH_TYPE", enableValue: true},
    {label: "Catégories", value: "CATEGORY", enableValue: true},
    {label: "Nutritionnels", value: "NUTRITIONAL", enableValue: true},
    {label: "Marketings", value: "MARKETING", enableValue: true}
]

export const displayTagTypeGroups = [
    {label: "Internes", key: "INTERNAL", types: ["INTERNAL"]},
    {label: "Catégories", key: "CATEGORY", types: ["DISH_TYPE", "CATEGORY"]},
    {label: "Nutritionnels", key: "NUTRITIONAL", types: ["NUTRITIONAL"]},
    {label: "Marketings", key: "MARKETING", types: ["MARKETING"]}
]

/**
 * same data for production and preproduction
 * @NOTE hardcoded in the code (see changeBalancedAndCGRules and in packaging in server)
 */
export const fitCornerTag = {
    id: "aDXmU5660W",
}

export const getFitCornerTag = (recipe) => {
    const internalTags = recipe?.internalTag || []
    return internalTags.find(tag => tag.objectId === fitCornerTag.id)
}
